import reduxStore from "../configureEnvStore";
import DetectRTC from "detectrtc";
import { CALL_DATA, DOCUMENT_VISIBILITY_STATE, GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import { NOTIFICATION_TYPES } from "../constants/DataTrackNotificationConstants";
import { MEDIA_PERMISSIONS } from "../constants/CallSettingConstants";
import { LogFirebase } from "../services/firestore";
import { assignSupportLinkForBrowser } from "./function";
import CustomToast from "../components/UI/customToast";
import Localize from "../locale/Localize";
import {
    setAllowMarkup,
    setAllowPointer,
    setAllowTakePhoto,
    setAudioPermissionDeniedMsg,
    setAudioVideoBlockforPopup,
    setCallParticipants,
    setIsVideoButtonClickDisable,
    setSupportLinkForAgent,
    setVideoPermissionDeniedMsg,
} from "../reducers/common-reducer";
import { dualStreamEnabled, getLocalBrowserInfo, isSafariBelow14 } from "./utility";
import { DEVICE_TYPES, DISABLE, ENABLED, MEASUREMENT_VIEW } from "../constants/Constants";
import zoomService from "../services/zoomService";
import { handleFlagsOnRecFail } from "../components/Recording/RecordingUtils";
import { pointerStatus } from "../constants/LivePointerConstants";
import { setPointerStCode } from "../reducers/livePointer-reducer";
import livePointerService from "../components/LivePointer/livePointerService";
import { getNetworkTypeTitle } from "../components/Network/NetworkUtils";
import { performStartStopVideo } from "../components/Twilio/VideoCall/VideoUtils";
import { FLASH_STATE } from "../constants/FlashConstants";
import { setFlashState } from "../reducers/flash-reducer";
import endCallService from "../services/endCallService";
import { showSpeakerMsgForiOSGuest } from "../components/Twilio/AudioCall/AudioCallUtils";
import { setForLocalRemoteCheck, setVideoNotSupported } from "../reducers/track-failed-reducer";
import { stopScreenShare } from "../components/Twilio/ScreenShare/ScreenShareUtils";
import { getLocalVideoTrack } from "../components/Twilio/Room/roomService";
import { attachTracks, getPublishVideoContainer, removeVideoElement, restartLocalVideoTracks } from "../components/Twilio/twilioCallUtility";
import { setOfflineModeUserIdentity } from "../reducers/offline-mode-reducer";
import { offlineModeDataTrack } from "../components/Twilio/DataTrack/allReceiveDataTrack";

/*  function sends datatrack message '202'  */
export const sendJoinDataTrack = () => {
    console.log("in send data track function");
    const localBrowserInfo = getLocalBrowserInfo();
    let msg = {};
    const { notAllowedCamera, allowedMicrophone } = reduxStore.getState().twilioEvents;
    if (GLOBAL_MEETING_DATA.isAgent) {
        msg.isAgent = true;
    } else {
        msg = {
            allowedCamera: !notAllowedCamera,
            allowedMicrophone: allowedMicrophone,
            allowedLocation: PublicVariables.allowedLocation,
            latitude: CALL_DATA.Latitude,
            longitude: CALL_DATA.Longitude,
            isAgent: false,
            webDevice: DetectRTC.osName,
            browserName: localBrowserInfo?.browserName,
            appVersion: localBrowserInfo?.browserVersion,
            networkType: CALL_DATA.callstatsNetType,
            networkSpeed: CALL_DATA.callstatsNetSpeed,
            guestName: CALL_DATA.participantUserName,
        };
    }

    msg.notification_type = NOTIFICATION_TYPES.PARTICIPANT_JOINED;
    msg.identity = CALL_DATA.localIdentity;
    msg.participantId = CALL_DATA.participantIdentity;
    msg.device_type = GLOBAL_MEETING_DATA.device_type;
    msg.activeuserlist = reduxStore.getState().commonReducer.activeuserlist;
    msg.totalusercount = parseInt(reduxStore.getState().commonReducer.totalUserCount);
    msg.username = CALL_DATA.participantUserName;
    msg.body = CALL_DATA.participantUserName + " joined the call";
    LogFirebase("UpdateNetwork", "network_type", CALL_DATA.callstatsNetType);
    LogFirebase("UpdateNetwork", "network_speed", CALL_DATA.callstatsNetSpeed);
    const { isRoomConnected } = reduxStore.getState().commonReducer;
    if (!isRoomConnected) {
        return true;
    }

    setTimeout(() => {
        sendDataTrack(msg);
    }, 2000);

    //// setTimeout(() => {
    sendDataTrack(msg);
    //// }, 4000);

    if (GLOBAL_MEETING_DATA.pid) {
        LogFirebase("disconnectUserRemotely", "participant_id", GLOBAL_MEETING_DATA.pid);
        /**
         * if app is not installed mWeb user join in new tab (only for Android mweb)
         * join user and call API with Participant ID which received in URL
         **/
        endCallService.disconnectMWebDeepLinkUser();
        GLOBAL_MEETING_DATA.pid = null;
    }
};

export const addCallParticipant = (message, from) => {
    const callParticipantsArray = [...reduxStore.getState().commonReducer.callParticipants];
    let updatedCallParticipantsArray = [...callParticipantsArray];
    let msg = {};

    if (from === "participantConnected") {
        msg = {
            identity: message.identity,
            latitude: "",
            longitude: "",
            isAgent: false,
        };
    } else {
        //from notification 202 and 207
        msg = message;
    }

    let userdetails = {
        displayName: "",
        jobRole: "",
        RCode: "",
        ucid: "",
        uEmail: "",
        participantId: msg.participantId,
        identity: msg.identity,
        fullName: msg.username,
        isAgent: msg.isAgent,
        device_type: msg.device_type,
        webDevice: msg.webDevice,
        browserName: msg.browserName,
        appVersion: msg.appVersion,
        isSilentObserver: false,
        ar_status: "",
    };

    if (!msg.allowedLocation) {
        userdetails.latitude = 0;
        userdetails.longitude = 0;
        msg.latitude = 0;
        msg.longitude = 0;
    } else {
        if (msg.latitude !== undefined || msg.latitude !== null) {
            userdetails.latitude = parseFloat(msg.latitude);
            userdetails.longitude = parseFloat(msg.longitude);
        } else {
            userdetails.latitude = "";
            userdetails.longitude = "";
            msg.latitude = "";
            msg.longitude = "";
        }
    }

    let userFound = false;

    callParticipantsArray.forEach(function (user) {
        if (user.identity == msg.identity) {
            userFound = true;
        }
    });

    if (!userFound) {
        callParticipantsArray.push(userdetails);
        updatedCallParticipantsArray = [...callParticipantsArray];
        reduxStore.dispatch(setCallParticipants(updatedCallParticipantsArray));
    } else {
        // Replace the forEach loops with map to ensure immutability
        updatedCallParticipantsArray = callParticipantsArray.map((user) => {
            if (user.identity === msg.identity) {
                // Return a new object with updated latitude and longitude
                return {
                    ...user,
                    latitude: parseFloat(msg.latitude),
                    longitude: parseFloat(msg.longitude),
                };
            }
            return user;
        });
        reduxStore.dispatch(setCallParticipants(updatedCallParticipantsArray));
    }
    console.log("addCallParticipant__: ", "from: ", from, "updatedCallParticipantsArray: ", updatedCallParticipantsArray);
    // Replace the forEach loops with map to ensure immutability
    const modifiedCallParticipantsArray = updatedCallParticipantsArray.map((user) => {
        if (user.identity === msg.identity) {
            // Modify user object if needed
            const newUpdatedUserData = {
                ...user,
                webDevice: msg.webDevice || user.webDevice,
                browserName: msg.browserName || user.browserName,
                uploadStatus: msg.uploadStatus || user.uploadStatus,
                networkType:
                    msg.notification_type === NOTIFICATION_TYPES.PARTICIPANT_JOINED && msg.networkType !== undefined
                        ? getNetworkTypeTitle(msg.networkType, msg.networkSpeed)
                        : user.networkType,
            };

            if (msg.appVersion) {
                newUpdatedUserData.appVersion =
                    msg.device_type === DEVICE_TYPES.ANDROID_APP
                        ? "Android App " + "v" + msg.appVersion
                        : msg.device_type === DEVICE_TYPES.IOS_APP
                          ? "iPhone App " + "v" + msg.appVersion
                          : msg.device_type === DEVICE_TYPES.SMART_GLASS
                            ? " v" + msg.appVersion
                            : msg.appVersion || user.appVersion;
            }

            return newUpdatedUserData;
        }
        return user;
    });
    console.log("addCallParticipant__: ", "from: ", from, "modifiedCallParticipantsArray: ", modifiedCallParticipantsArray);
    reduxStore.dispatch(setCallParticipants(modifiedCallParticipantsArray));
};

export const handleCallPartcipantArrayOnJoin = () => {
    let callParticipantsArray = [];
    let userdetail = {
        displayName: "",
        jobRole: "",
        RCode: "",
        ucid: "",
        uEmail: "",
        participantId: CALL_DATA.participantIdentity,
        identity: CALL_DATA.localIdentity,
        device_type: GLOBAL_MEETING_DATA.device_type,
        latitude: CALL_DATA.Latitude,
        longitude: CALL_DATA.Longitude,
        networkQuality: 1, //just initialized, will be changed when NQ received
        networkType: CALL_DATA.callstatsNetType,
        networkSpeed: CALL_DATA.callstatsNetSpeed,
    };

    userdetail.fullName = CALL_DATA.participantUserName;
    callParticipantsArray.push(userdetail);
    reduxStore.dispatch(setCallParticipants(callParticipantsArray));
};

export const updateParticipantNames = () => {
    console.log("need to handle when dual stream ON");
};

let userJoinedStatus = [];
export const showToastMessages = (msg) => {
    if (
        msg.device_type == DEVICE_TYPES.IOS_BROWSER &&
        PublicVariables.featureFlag?.SHOWMEMICROPHONE === ENABLED &&
        !CALL_DATA.gblAudioAgentMsgShown
    ) {
        showSpeakerMsgForiOSGuest(msg.identity);
    }

    if (GLOBAL_MEETING_DATA.isAgent) {
        let msgShownForUser = false;
        if (userJoinedStatus != null) {
            msgShownForUser = userJoinedStatus.includes(msg.identity);
        }
        if (!msgShownForUser) {
            userJoinedStatus.push(msg.identity); // handles multiple agent case
            setTimeout(() => {
                const connectedMessage = getMessage(msg); //when participant joins

                CustomToast.success(connectedMessage);
            }, 1000);
        } else {
            console.log("user already exist");
        }
    }
};

const getMessage = (msg) => {
    let connectedMessage = "";
    if (msg.guestName) {
        connectedMessage = `${msg.guestName} ${Localize[PublicVariables.currentLanguageObj.languageCode]["connected"].toLowerCase()}`;
    } else {
        const partiIndex = getParticipantIndex(msg.identity);
        connectedMessage = `${partiIndex} ${Localize[PublicVariables.currentLanguageObj.languageCode]["connected"].toLowerCase()}`;
    }
    return connectedMessage;
};

export const getParticipantIdentity = (room, targetSid) => {
    // 1. Check local
    if (room?.localParticipant?.sid === targetSid) {
        return room.localParticipant.identity; // return identity instead of sid
    }

    // 2. Check remote using Array.find
    const participant = [...room?.participants?.values()]?.find((p) => p.sid === targetSid);

    return participant ? participant.identity : null;
};

/**returns participant index : 1,2 etc to show like Participant 2's internet is unstable */
export const getParticipantIndex = (identity) => {
    let partiIndexOrName = "";
    let partiLabel = Localize[PublicVariables.currentLanguageObj.languageCode]["participant"];
    const newUserList = reduxStore.getState().commonReducer.newActiveUserList;
    if (newUserList && Object.keys(newUserList).length > 0 && newUserList[identity]) {
        partiIndexOrName = newUserList[identity];
        if (partiIndexOrName && typeof partiIndexOrName != "number") {
            console.log("participant is exist");
        } else {
            partiIndexOrName = partiLabel + " " + partiIndexOrName;
        }
    }
    return partiIndexOrName;
};

export const getLocalPartiName = () => {
    //once we receive index
    let participantName = Localize[PublicVariables.currentLanguageObj.languageCode]["participant"];
    let youLabel = " " + Localize[PublicVariables.currentLanguageObj.languageCode]["you"];
    if (GLOBAL_MEETING_DATA.isAgent) {
        participantName = GLOBAL_MEETING_DATA.blitzzUserName + youLabel;
    } else {
        participantName = getParticipantIndex(CALL_DATA.localIdentity);
        participantName = participantName + youLabel;
    }
    return participantName;
};

export const micCameraPermissionDatatrackSend = (fromWhere) => {
    const callConnected = reduxStore.getState().commonReducer.isRemoteParticipantJoined;
    if (callConnected) {
        if (fromWhere === "mic") {
            handleMicrophonePermissionDatatrack(); // handle data track for show audio icon to agent
        } else {
            handleCameraPermissionDatatrack(); // handle data track for show video icon to agent
        }
    }
};

export const handleMicrophonePermissionDatatrack = () => {
    let assigeCameraPermission = "";
    const browserInfo = getLocalBrowserInfo();
    const micPermission = reduxStore.getState().callSetting.audioPermission;

    if (micPermission == MEDIA_PERMISSIONS.PROMPT) {
        assigeCameraPermission = MEDIA_PERMISSIONS.PROMPT_VALUE;
    } else if (micPermission == MEDIA_PERMISSIONS.GRANTED) {
        assigeCameraPermission = MEDIA_PERMISSIONS.GRANTED_VALUE;
    } else if (micPermission == MEDIA_PERMISSIONS.BLOCKED) {
        assigeCameraPermission = MEDIA_PERMISSIONS.BLOCKED_VALUE;
    } else if (!DetectRTC.hasMicrophone) {
        assigeCameraPermission = MEDIA_PERMISSIONS.PROMPT_VALUE;
    }
    if (!GLOBAL_MEETING_DATA.isAgent) {
        const msg = {
            notification_type: NOTIFICATION_TYPES.MICROPHONE_PERMISSION,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            permission_status: assigeCameraPermission,
            webDevice: DetectRTC.osName,
            browserName: browserInfo.browserName,
            appVersion: browserInfo.browserVersion,
        };
        sendDataTrack(msg);
        console.log(msg);
        if (!DetectRTC.hasMicrophone) {
            LogFirebase("PERMISSION", "MICROPHONE_PERMISSION ", "MICROPHONE NOT FOUND");
        } else {
            LogFirebase("PERMISSION", "MICROPHONE_PERMISSION ", micPermission);
        }
    }
};

/*  function sends datatrack message '209'  */
export const handleCameraPermissionDatatrack = () => {
    let assigeCameraPermission = "";
    const browserInfo = getLocalBrowserInfo();
    const cameraPermission = reduxStore.getState().callSetting.cameraPermission;

    if (cameraPermission == MEDIA_PERMISSIONS.PROMPT) {
        assigeCameraPermission = MEDIA_PERMISSIONS.PROMPT_VALUE;
    } else if (cameraPermission == MEDIA_PERMISSIONS.GRANTED) {
        assigeCameraPermission = MEDIA_PERMISSIONS.GRANTED_VALUE;
    } else if (cameraPermission == MEDIA_PERMISSIONS.BLOCKED) {
        assigeCameraPermission = MEDIA_PERMISSIONS.BLOCKED_VALUE;
    } else if (!DetectRTC.hasWebcam) {
        assigeCameraPermission = MEDIA_PERMISSIONS.PROMPT_VALUE;
    }
    if (!GLOBAL_MEETING_DATA.isAgent) {
        const msg = {
            notification_type: NOTIFICATION_TYPES.CAMERA_PERMISSION,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            permission_status: assigeCameraPermission,
            webDevice: DetectRTC.osName,
            browserName: browserInfo.browserName,
            appVersion: browserInfo.browserVersion,
        };
        sendDataTrack(msg);
        console.log(msg);
        if (!DetectRTC.hasWebcam) {
            LogFirebase("PERMISSION", "CAMERA_PERMISSION ", "CAMERA NOT FOUND");
        } else {
            LogFirebase("PERMISSION", "CAMERA_PERMISSION ", cameraPermission);
        }
    }
};

let timerVariableAudioVideoBlockMsg = null;
export const closeAudioVideoBlockMsg = function (forced) {
    if (forced) {
        clearTimeout(timerVariableAudioVideoBlockMsg);
        reduxStore.dispatch(setAudioPermissionDeniedMsg(false));
        reduxStore.dispatch(setVideoPermissionDeniedMsg(false));
        reduxStore.dispatch(setAudioVideoBlockforPopup(false));
    } else {
        /**hide the audio video block popup msg info popup after 15 seconds */
        timerVariableAudioVideoBlockMsg = setTimeout(function () {
            const { isRemoteParticipantJoined } = reduxStore.getState().commonReducer;
            if (isRemoteParticipantJoined) {
                //so that fadeout effect can be seen
                clearTimeout(timerVariableAudioVideoBlockMsg);
                reduxStore.dispatch(setAudioPermissionDeniedMsg(false));
                reduxStore.dispatch(setVideoPermissionDeniedMsg(false));
                reduxStore.dispatch(setAudioVideoBlockforPopup(false));
            } else {
                console.log("do nothing");
            }
        }, 15000);
    }
};

export const updateParticipantAudioInfo = (msg) => {
    const callParticipants = reduxStore.getState().commonReducer.callParticipants;

    const updatedParticipants = callParticipants.map((user) => {
        if (user.identity === msg.identity) {
            if (msg.permission_status == "2") {
                console.log("assignSupportLinkForBrowser");
                const link = assignSupportLinkForBrowser(msg);
                reduxStore.dispatch(setSupportLinkForAgent(link));
                closeAudioVideoBlockMsg();
                reduxStore.dispatch(setAudioVideoBlockforPopup(true));
                reduxStore.dispatch(setAudioPermissionDeniedMsg(true));
            }
            return { ...user, audioPermission: msg.permission_status };
        }
        return user;
    });
    reduxStore.dispatch(setCallParticipants(updatedParticipants));
};

export const updateParticipantVideoInfo = (msg, videoParams) => {
    const callParticipants = reduxStore.getState().commonReducer.callParticipants;
    const updatedParticipants = callParticipants.map((user) => {
        if (user.identity === msg.identity) {
            if (msg.permission_status == "2" && GLOBAL_MEETING_DATA.isAgent) {
                console.log("assignSupportLinkForBrowser");
                const link = assignSupportLinkForBrowser(msg);
                reduxStore.dispatch(setSupportLinkForAgent(link));
                closeAudioVideoBlockMsg();
                reduxStore.dispatch(setAudioVideoBlockforPopup(true));
                reduxStore.dispatch(setVideoPermissionDeniedMsg(true));
            }
            return { ...user, videoPermission: msg.permission_status };
        }
        return user;
    });
    reduxStore.dispatch(setCallParticipants(updatedParticipants));
};

export const handleReceiveVideoScreenShareDataTrack = (msg) => {
    const { streamingPartiIdentity: streamingIdentity, isLocalUserScreenSharing } = reduxStore.getState().twilioEvents;
    // do not remove if else part
    if (dualStreamEnabled()) {
        if (msg.identity == streamingIdentity) {
            toggleActionButtons(msg);
        }
    } else {
        toggleActionButtons(msg);
    }
    if (msg.is_videostream === DISABLE) {
        //screen share
        LogFirebase("Screenshare", "received_msg", msg);
        if (msg.status === ENABLED) {
            if (!dualStreamEnabled() && isLocalUserScreenSharing) {
                //when someone overrides screenshare
                stopScreenShare(false);
                LogFirebase("Screenshare", "local_screenshare_on", "Local screen share will be overrriden by remote SS");
            }
            setTimeout(() => {
                CALL_DATA.disabledFlash = true;
                console.log("disable flash button");
            }, 200);

            if (msg.show_toast === ENABLED) {
                CustomToast.success(Localize[PublicVariables.currentLanguageObj.languageCode]["started_screen_share"]);
            }
        } else {
            CustomToast.success(Localize[PublicVariables.currentLanguageObj.languageCode]["stopped_screen_share"]);
        }
    } else {
        if (msg.device_type === DEVICE_TYPES.DESKTOP && msg.status === ENABLED) {
            CALL_DATA.disabledFlash = true;
            reduxStore.dispatch(setFlashState(FLASH_STATE.DISABLED));
            console.log("disable flash button");
        }
        //nothing for normal video stream
    }
    // when SS or video - on/off -> need to disable or reset pinch zoom
    if (PublicVariables.isMobile) {
        zoomService.disablePinchZoom();
        if (reduxStore.getState().twilioEvents.startLocalVideo) {
            console.log("startLocalVideo true");
        } else {
            setTimeout(function () {
                if (!zoomService.disablepinchOnmarkup) {
                    // if mark up is not on then reset pinch zoom
                    console.log("in reset zoom if markup is not in progress");
                    zoomService.resetPinchZoom();
                }
            }, 1000);
        }
    }
};

export const handleSendVideoScreenShareDataTrack = (status, isVideoStreaming, showToastOrNot, callBackFn) => {
    const msg = {
        notification_type: NOTIFICATION_TYPES.VIDEO_SCREENSHARE_STATUS,
        identity: CALL_DATA.localIdentity,
        status: status, // 1=Enable, 0=Disable
        device_type: GLOBAL_MEETING_DATA.device_type,
        is_videostream: isVideoStreaming, // 1 = video, 0 = screenshare
        show_toast: showToastOrNot,
    };
    sendDataTrack(msg);
    if (callBackFn) callBackFn(msg);
};

export const toggleActionButtons = (msg) => {
    const isIOSApp = msg?.device_type === DEVICE_TYPES.IOS_APP;
    const isWebOrAndroid = msg?.device_type !== DEVICE_TYPES.IOS_APP && msg?.status === ENABLED;
    const isDesktopOrBrowser =
        msg?.device_type === DEVICE_TYPES.DESKTOP ||
        msg?.device_type === DEVICE_TYPES.ANDROID_BROWSER ||
        msg?.device_type === DEVICE_TYPES.IOS_BROWSER;
    const isVideoStreamEnabled = msg?.is_videostream === ENABLED && msg?.status === ENABLED;
    const isVideoStreamDisabled = msg?.is_videostream === DISABLE && msg?.status === ENABLED;

    // Handle iOS device
    if (isIOSApp) {
        if (isVideoStreamDisabled) {
            // iOS app with screen share ON (guest)
            reduxStore.dispatch(setAllowMarkup(false));
            reduxStore.dispatch(setAllowTakePhoto(false));
            reduxStore.dispatch(setAllowPointer(false));
        } else if (isVideoStreamEnabled) {
            // iOS app with normal video stream (guest)
            reduxStore.dispatch(setAllowMarkup(true));
            reduxStore.dispatch(setAllowTakePhoto(true));
            reduxStore.dispatch(setAllowPointer(true));
        }
    }

    // Handle any other device with status ENABLED
    if (isWebOrAndroid) {
        reduxStore.dispatch(setAllowMarkup(true));
        reduxStore.dispatch(setAllowPointer(true)); // single stream, iOS ss on and android override with SS LP btn disable issue resolve
        reduxStore.dispatch(setAllowTakePhoto(true));
    }

    // handle this condition wen iOS screen share override by Web/mWeb video or screenshare
    if (isDesktopOrBrowser && msg?.status === ENABLED) {
        reduxStore.dispatch(setAllowPointer(true));
    }
};

export const sendDataTrack = (message) => {
    const { dataTrack } = reduxStore.getState().twilioEvents;
    dataTrack?.send(JSON.stringify(message));
};

export const sendStartRecordingMsg = (status, roomName) => {
    let recRoomName;
    if (roomName && roomName == "NA") {
        recRoomName = "";
    } else {
        recRoomName = GLOBAL_MEETING_DATA.sessionId;
    }
    const msg = {
        notification_type: NOTIFICATION_TYPES.RECORDING.START,
        status: status, //send initial start REC message 1=initilize, 2=start
        identity: CALL_DATA.localIdentity,
        device_type: GLOBAL_MEETING_DATA.device_type,
        room_name: recRoomName,
    };
    sendDataTrack(msg);
};

export const sendStopRecordingMsg = () => {
    const msg = {
        notification_type: NOTIFICATION_TYPES.RECORDING.STOP,
        identity: CALL_DATA.localIdentity,
        device_type: GLOBAL_MEETING_DATA.device_type,
    };

    sendDataTrack(msg);
};

export const sendRecordingError = (error) => {
    let errStatus,
        notificationType = "";
    if (GLOBAL_MEETING_DATA.isAgent) {
        notificationType = NOTIFICATION_TYPES.RECORDING.START_ERROR;
        CustomToast.error(Localize[PublicVariables.currentLanguageObj.languageCode]["error_recording_please_try_again"]);
        //Error recording, you can wait or you can disconnect the call
    }

    const msg = {
        notification_type: notificationType,
        identity: CALL_DATA.localIdentity,
        device_type: GLOBAL_MEETING_DATA.device_type,
        room_name: GLOBAL_MEETING_DATA.sessionId,
        error_code: error.Errorcode ? error.Errorcode : "",
        error: error.Error ? error.Error : "",
        status: errStatus, // this will not be used now as guest user is not send the notification
    };

    sendDataTrack(msg);
    handleFlagsOnRecFail();
};

export const checkPublishVideoOnExit = () => {
    if (!dualStreamEnabled()) {
        if (CALL_DATA.myVideoON) {
            CALL_DATA.myVideoON = false;
            //// when browser in background - do not publish
            if (document.visibilityState && document.visibilityState !== DOCUMENT_VISIBILITY_STATE.HIDDEN) {
                performStartStopVideo();
            }
        }
    }
};

export const checkIfLocalTrackReattach = () => {
    if (PublicVariables.isMobile && dualStreamEnabled()) {
        //    perform dual stram related changes
        //    this will run when user come back from Upload Files view in dual steam call
        //    and it is restarting video tracks by updating UI
        //    and applies for Mobile only, not for desktop
        setTimeout(() => {
            let localtracks = getLocalVideoTrack();
            if (localtracks) {
                let localContainer = getPublishVideoContainer();
                removeVideoElement(localContainer);
                attachTracks([localtracks], localContainer, "fromCallBack", function () {
                    if (isSafariBelow14()) {
                        restartLocalVideoTracks();
                    }
                });
            }
        }, 1000);
    }
};

export const sendMsgForPointer = (pointerSt, showtoast) => {
    const { livePointerColors } = reduxStore.getState().livePointer;
    if (livePointerService.getLivePointerFeatureFlagValue() == ENABLED) {
        /* 602
            -pointerstatus = 1 for turn ON live pointer 
            -pointerstatus = 2 for turn OFF live pointer 
        */
        let pointerKey = "ON";
        let pointerStatusVal = "";
        if (showtoast == undefined) {
            showtoast = "0";
        }
        if (pointerSt != undefined) {
            pointerKey = pointerSt;
        }
        pointerStatusVal = pointerStatus[pointerKey].toString();
        reduxStore.dispatch(setPointerStCode(pointerStatusVal));
        const msg = {
            notification_type: NOTIFICATION_TYPES.LIVEPOINTER.STATUS_START_STOP,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            show_toast: showtoast,
            oldAppAutoLP: "0",
            livepointer_data: JSON.stringify({ USERCOLORS: livePointerColors, POINTERSTATUS: parseInt(pointerStatusVal) }),
        };
        console.log("STATUS_START_STOP_send_: ", msg, "Status: ", parseInt(pointerStatusVal));

        sendDataTrack(msg);
        LogFirebase("LivePointer", "send_msg", pointerStatusVal);
    }
};

const handleDisconnectMWebDeepLinkUser = async () => {
    try {
        const result = await endCallService.endCallServiceFunction();
        console.log("result ===> ", result);
    } catch (e) {
        console.log(e);
    }
};

export const checkVideoSupport = (fromwhere) => {
    if (fromwhere == "remote") {
        const msg = {
            message: "Remote Video subscription failed",
            notification_type: NOTIFICATION_TYPES.REMOTE_VIDEO.SUBSCRIPTION_FAILED,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
        };
        console.error(msg);
        sendDataTrack(msg);
    }
    reduxStore.dispatch(setVideoNotSupported(true));
    reduxStore.dispatch(setForLocalRemoteCheck(fromwhere));
    reduxStore.dispatch(setIsVideoButtonClickDisable(false)); // enable video button(button click variable)
};

export const sendMeasurementMsg = () => {
    const { measurementStarted, measurementView } = reduxStore.getState().measurement;
    if (
        GLOBAL_MEETING_DATA.ucid &&
        measurementStarted &&
        (measurementView === MEASUREMENT_VIEW.PREPARE_VIEW || measurementView === MEASUREMENT_VIEW.START_MEASUREMENT_VIEW) &&
        !dualStreamEnabled()
    ) {
        setTimeout(() => {
            const msg = {
                notification_type: NOTIFICATION_TYPES.MEASUREMENT_START_STOP,
                identity: CALL_DATA.localIdentity,
                device_type: GLOBAL_MEETING_DATA.device_type,
                measurement_status: "1",
                for_new_joinee: "1",
            };
            sendDataTrack(msg);
        }, 2000);
    }
};

export const sendRemoveParticipantByHostDataTrack = (removeStatus, rejoinStatus = DISABLE, removeIdentity = "") => {
    const message = {
        notification_type: NOTIFICATION_TYPES.HOST_TO_GUEST.REMOVE_USER,
        device_type: GLOBAL_MEETING_DATA.device_type,
        identity: CALL_DATA.localIdentity, // sender identity
        remove_user_identity: removeIdentity, // identity who's user agent want to disconnect, // empty if remove all user
        status: removeStatus, // 1: for individual and 2: for remove all
        rejoin_not_allowed: rejoinStatus, // 0: rejoin allow, 1: rejoin not allow
    };
    sendDataTrack(message);
};

export const sendAudioOnOffForParticipantDataTrack = (audioStatus, muteUnmuteUserIdentity = "") => {
    const message = {
        notification_type: NOTIFICATION_TYPES.HOST_TO_GUEST.AUDIO_ON_OFF,
        device_type: GLOBAL_MEETING_DATA.device_type,
        identity: CALL_DATA.localIdentity, // sender identity
        mute_unmute_identity: muteUnmuteUserIdentity, // identity who's user agent want to mute/unmute // turn off all audio ma empty
        status: audioStatus, // 1: mute, 0: unmute, 2: mute for all user
    };
    sendDataTrack(message);
};

export const sendVideoOnOffForParticipantDataTrack = (videoStatus, startStopVideoUserIdentity = "") => {
    const message = {
        notification_type: NOTIFICATION_TYPES.HOST_TO_GUEST.VIDEO_START_STOP,
        device_type: GLOBAL_MEETING_DATA.device_type,
        identity: CALL_DATA.localIdentity, // sender identity
        video_start_stop_identity: startStopVideoUserIdentity, // identity who's user agent want to start/stop // turn off all video ma empty
        status: videoStatus, // 1: start, 0: stop, 2: stop for all user
    };
    sendDataTrack(message);
};

export const sendScreenshareOnOffForParticipantDataTrack = (screenshareStatus, startStopScreenshareUserIdentity = "") => {
    const message = {
        notification_type: NOTIFICATION_TYPES.HOST_TO_GUEST.SCREENSHARE_START_STOP,
        device_type: GLOBAL_MEETING_DATA.device_type,
        identity: CALL_DATA.localIdentity, // sender identity
        screenshare_start_stop_identity: startStopScreenshareUserIdentity, // identity who's user screenshare agent want to start/stop // turn off all screenshare ma empty
        status: screenshareStatus, // 1: start, 0: stop, 2: stop for all user
    };
    sendDataTrack(message);
};

export const sendScreenshareStatusToAgent = (screenshareStatus) => {
    const message = {
        notification_type: NOTIFICATION_TYPES.SCREENSHARE_STATUS,
        device_type: GLOBAL_MEETING_DATA.device_type, // sender device type
        identity: CALL_DATA.localIdentity, // sender identity
        status: screenshareStatus, // 1: start, 0: stop
    };
    sendDataTrack(message);
};

export const sendVideoStatusToAgent = (videoStatus) => {
    const message = {
        notification_type: NOTIFICATION_TYPES.VIDEO_STATUS,
        device_type: GLOBAL_MEETING_DATA.device_type, // sender device type
        identity: CALL_DATA.localIdentity, // sender identity
        status: videoStatus, // 1: start, 0: stop
    };
    sendDataTrack(message);
};

// for Mic/Camera request data track
export const sendRequestToAgentStartAudioOrVideo = (requestType, participantName) => {
    const message = {
        notification_type: NOTIFICATION_TYPES.REQUEST_PERMISSION_TO_AGENT_FOR_MIC_CAMERA_STRAT, // Request permission to start Mic/Camera
        device_type: GLOBAL_MEETING_DATA.device_type, // sender device type
        identity: CALL_DATA.localIdentity, // sender identity
        request_type: requestType, // 1 mic, 2 Camera
        participant_name: participantName, // participant name(sender)
    };
    sendDataTrack(message);
};

// Sends mic permission response (accepted/rejected) from agent to guest
export const sendMicPermissionResponseToGuest = (requestIdentity, permissionStatus) => {
    const message = {
        notification_type: NOTIFICATION_TYPES.REQUESTED_MIC_PERMISSION_ACCEPTED_REJECTED_BY_AGENT, // Notification type for mic permission response
        device_type: GLOBAL_MEETING_DATA.device_type, // Sender's device type
        identity: CALL_DATA.localIdentity, // Sender's identity (agent)
        request_user_identity: requestIdentity, // Identity of the user who requested mic permission
        mic_request_permission_status: permissionStatus, // 0 = Rejected, 1 = Accepted
    };
    sendDataTrack(message);
};

// Sends camera permission response (accepted/rejected) from agent to guest
export const sendCameraPermissionResponseToGuest = (requestIdentity, permissionStatus) => {
    const message = {
        notification_type: NOTIFICATION_TYPES.REQUESTED_CAMERA_PERMISSION_ACCEPTED_REJECTED_BY_AGENT, // Notification type for camera permission response
        device_type: GLOBAL_MEETING_DATA.device_type, // Sender's device type
        identity: CALL_DATA.localIdentity, // Sender's identity (agent)
        request_user_identity: requestIdentity, // Identity of the user who requested camera permission
        camera_request_permission_status: permissionStatus, // 0 = Rejected, 1 = Accepted
    };
    sendDataTrack(message);
};

export const handleSendOfflineModeCommandToGuestUser = (offlineModeUserId) => {
    if (CALL_DATA.iOSPrivateMode && offlineModeUserId == CALL_DATA.localIdentity) {
        // Check if iOS private mode is active for Agent
        const localisedValues = Localize[PublicVariables.currentLanguageObj.languageCode];
        CustomToast.info(
            localisedValues?.offline_uploads_are_not_supported_in_private_mode +
                " " +
                localisedValues?.please_switch_to_a_normal_browser_tab_to_use_this_feature
        );
        return; // Do not send offline mode command if iOS private mode is active
    }
    CALL_DATA.isOfflineModeActive = true; // Set the offline mode flag
    const message = {
        notification_type: NOTIFICATION_TYPES.OFFLINE_MODE.START, // notification type
        device_type: GLOBAL_MEETING_DATA.device_type, // sender device type
        identity: CALL_DATA.localIdentity, // sender identity
        offline_mode_user_identity: offlineModeUserId, // identity of the user who is going offline
    };
    sendDataTrack(message);
    const { offlineModeUserIdentity } = reduxStore.getState().offlineMode;
    LogFirebase("OfflineMode", "total_user_with_offline_mode_when_send_data_track", {
        already_offline_started_user_identity: offlineModeUserIdentity,
        new_offline_mode_user_identity: offlineModeUserId,
        total_user_with_offline_mode: [...offlineModeUserIdentity, offlineModeUserId],
    });
    reduxStore.dispatch(setOfflineModeUserIdentity([...offlineModeUserIdentity, offlineModeUserId]));
    if (offlineModeUserId === CALL_DATA.localIdentity) {
        LogFirebase("OfflineMode", "Agent_start_own", "identity_match_send_data_track");
        offlineModeDataTrack(message);
    }
};

export const sendDataForRejoinCallOfflineModeUser = (userId) => {
    const message = {
        notification_type: NOTIFICATION_TYPES.OFFLINE_MODE.RECONNECT_USER, // notification type
        device_type: GLOBAL_MEETING_DATA.device_type, // sender device type
        identity: CALL_DATA.localIdentity, // sender identity
        offline_mode_user_identity: userId, // identity of the user who is going offline
    };
    sendDataTrack(message);
    LogFirebase("OfflineMode", "send_data_track_when_offline_mode_user_reconnect", {
        previous_offline_mode_user_identity: userId,
        current_user_identity: CALL_DATA.localIdentity,
    });
};

export const sendBackToAllUserForOfflineModeNotSupported = async () => {
    const message = {
        notification_type: NOTIFICATION_TYPES.OFFLINE_MODE.PRIVATE_MODE_NOT_SUPPORTED,
        device_type: GLOBAL_MEETING_DATA.device_type,
        identity: CALL_DATA.localIdentity, // sender identity
        private_mode: true, // true for private mode
    };
    await new Promise((resolve) => setTimeout(resolve, 200));
    sendDataTrack(message);
};
